"use client";

import { useSession } from "@/context/SessionContext";
import { importRefusalMessage } from "@/utils/import/importUsage";
import type {
  ImportBlockType,
  ImportRefusalType,
  ImportUsageStatusType,
} from "@/utils/serverActions/import/importActions";

/**
 * The import runs in chunks. When something stops it in the middle, the chunks that
 * ran stay imported: this says why it stopped and how many rows were left.
 */
export default function ImportStopNotice({
  result,
}: {
  result: {
    refused?: ImportRefusalType;
    usage?: ImportUsageStatusType;
    block?: ImportBlockType;
    interrupted?: string;
    rowsNotRun?: number;
  };
}) {
  const { session } = useSession();
  if (!result.refused && !result.interrupted) return null;

  const why = result.refused
    ? importRefusalMessage(result.refused, result.usage, result.block, session.usesHour12)
    : result.interrupted;
  const left = result.rowsNotRun ?? 0;

  return (
    <div
      role="alert"
      data-testid="import-stopped"
      className="mb-6 rounded border border-yellow-300 bg-yellow-50 p-4 text-sm text-yellow-900 space-y-1"
    >
      <p className="font-medium">
        La importación se detuvo antes de terminar{left > 0 ? `: ${left.toLocaleString("es")} filas no se importaron` : ""}.
      </p>
      <p>{why}</p>
      <p>Lo que ya se importó queda guardado. Si importas el archivo otra vez, esas filas no se duplican, pero cuentan de nuevo para tu límite.</p>
    </div>
  );
}
